import React from 'react';
import { useSelector } from 'react-redux';

export const usePagination = () => {
    const { count: total, current } = useSelector((state) => state.paymentReducer.pagination);

    const getPagination = (currentPage) => {
        const pagination = [];
        let i = 1;
        let maxCount = 7;
        if (total <= 7) {
            return Array(total)
                .fill()
                .map((_, i) => i + 1);
        } else {
            if (currentPage < 5) {
                while (i <= maxCount) {
                    if (i === 6) {
                        pagination.push('...');
                    } else if (i === maxCount) {
                        pagination.push(total);
                    } else {
                        pagination.push(i);
                    }
                    i++;
                }
            }
            if (currentPage >= total - 3) {
                let i = total;
                const newRes = [];
                while (i >= total - 4) {
                    newRes.push(i);
                    i--;
                }
                return [1, '...', ...newRes.reverse()];
            }
            if (total > 7 && currentPage > 4 && total - 3 > currentPage) {
                let i = currentPage - 1;
                const pages = Array(3)
                    .fill()
                    .map((_) => {
                        let res = i;
                        i++;
                        return res;
                    });

                return [1, '...', ...pages, '...', total];
            }
        }
        return pagination;
    };

    const paginationArray = getPagination(current);

    return { paginationArray };
};
